module.exports = __webpack_public_path__ + "images/dawn_dusk-4d7352f77cbfbb21bc9afd471e49abbf.jpg";